import React from 'react';
import { BannersCarouselSlider } from './banners-carousel-slider';
import { BannersCarouselItemsList } from './banners-carousel-items-list';
import { BannersCarouselProps } from '../types';
import { enrichContent } from '../utils';
import { AtMobile, AtTablet, FromDesktop } from 'common/components/adaptive';

export const BannersCarousel: React.FC<BannersCarouselProps> = props => {
  const {
    autoplay,
    loop,
    slidesPerView,
    adaptiveImpression,
    onImpressionContentClick,
    onImpressionContentView,
    adaptiveMode = 'strict',
    targetBlank,
  } = props;

  const { desktop, tablet, mobile } = adaptiveImpression;

  const commonProps = {
    onImpressionContentClick,
    onImpressionContentView,
    targetBlank,
  };

  const desktopBanners = desktop ? enrichContent(desktop.content, desktop.contentType) : null;
  let tabletBanners = tablet ? enrichContent(tablet.content, tablet.contentType) : null;
  let mobileBanners = mobile ? enrichContent(mobile.content, mobile.contentType) : null;

  if (adaptiveMode === 'resize') {
    tabletBanners = desktopBanners;
    mobileBanners = desktopBanners;
  }

  if (adaptiveMode === 'no-tablet') {
    tabletBanners = desktopBanners;
  }

  if (adaptiveMode === 'no-mobile') {
    mobileBanners = tabletBanners;
  }

  return (
    <>
      {desktopBanners && (
        <FromDesktop>
          <BannersCarouselSlider
            {...{ autoplay, loop, slidesPerView }}
            data-qa="banners-carousel-slider-desktop">
            <BannersCarouselItemsList content={desktopBanners} {...commonProps} />
          </BannersCarouselSlider>
        </FromDesktop>
      )}
      {tabletBanners && (
        <AtTablet>
          <BannersCarouselSlider
            {...{ autoplay, loop, slidesPerView }}
            data-qa="banners-carousel-slider-tablet">
            <BannersCarouselItemsList content={tabletBanners} {...commonProps} />
          </BannersCarouselSlider>
        </AtTablet>
      )}
      {mobileBanners && (
        <AtMobile>
          <BannersCarouselSlider
            {...{ autoplay, loop, slidesPerView: 'auto' }}
            data-qa="banners-carousel-slider-mobile">
            <BannersCarouselItemsList content={mobileBanners} {...commonProps} />
          </BannersCarouselSlider>
        </AtMobile>
      )}
    </>
  );
};
